var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60.1 50 37.8-37.8c2.8-2.8 2.8-7.3 0-10.1s-7.3-2.8-10.1 0L50 39.9 12.2 2.1C9.4-.7 4.9-.7 2.1 2.1s-2.8 7.3 0 10.1L39.9 50 2.1 87.8c-2.8 2.8-2.8 7.3 0 10.1 1.4 1.4 3.2 2.1 5.1 2.1 1.8 0 3.7-.7 5-2.1L50 60.1l37.8 37.8c1.4 1.4 3.2 2.1 5.1 2.1 1.8 0 3.7-.7 5-2.1 2.8-2.8 2.8-7.3 0-10.1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export default ForwardRef;